import { useState } from 'react';
import Button from '@/components/ui/Button';
import WatchlistMultiFilter from './WatchlistMultiFilter';
import { ESMExitedStocksFilterOptions } from '@/types/esmExitedStocks';

interface ESMExitedStocksFilterFormProps {
  filterOptions: ESMExitedStocksFilterOptions;
  onSubmit: (filters: Record<string, unknown>) => void;
  isLoading?: boolean;
}

export default function ESMExitedStocksFilterForm({ filterOptions, onSubmit, isLoading = false }: ESMExitedStocksFilterFormProps) {
  const [filters, setFilters] = useState({
    watchlist_ids: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFilters({
      watchlist_ids: '',
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Clean up filters - remove empty strings
    const cleanedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, unknown>);
    
    onSubmit(cleanedFilters);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row sm:items-end gap-3 p-6">
      <div className="w-full sm:w-80">
        <WatchlistMultiFilter
          value={filters.watchlist_ids}
          onChange={handleChange}
          watchlists={filterOptions.watchlists || []}
          label="Watchlists"
          placeholder="Select watchlists..."
        />
      </div>

      <Button
        type="submit"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <svg className="animate-spin -ml-1 mr-1 h-3 w-3 text-white" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Searching...
          </>
        ) : (
          'Search'
        )}
      </Button>
      <Button
        type="button"
        onClick={handleReset}
        disabled={isLoading}
        variant="outline"
      >
        Reset
      </Button>
    </form>
  );
}
